export default __webpack_public_path__ + "static/media/Form.f9cf732d.svg";